import { createContext } from "react";
import useAuthProviderValue from "../hooks/useAuthProviderValue";

export const AuthContext = createContext()

const AuthProvider = ({ children }) => {

    const value = useAuthProviderValue()

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;